/** * * Asynchronously loads the component for
CreateSupportTicket
* */ import { lazyLoad } from "utils/loadable";
export const CreateSupportTicket = lazyLoad(
  () => import("./index"),
  (module) => module.CreateSupportTicket
);
